import styled from "styled-components";

export const Tr = styled.tr`
  height: 200px;
  background-color: ${(props) => props.theme.colors.white};
`;

export const Row = styled.div`
  left: 50%;
  display: inline-block;
  position: sticky;
`;

export const Text = styled.span`
  display: inline-block;
  transform: translateX(-50%);
  font-size: 0.8rem;
  color: ${(props) => props.theme.colors.text};
`;
